import { css } from 'linaria';

export const elevateAutocompleteTitleStyle = css`
  color: #0d3923;
  font-family: Figtree;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 15px;
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-bottom: 16px;
`;
